/**
  * This script is a hack to fix an issue with Flickity on inintial load that results in 
  * the slider not being able to calculate the correct height until the window is resized.
  * This script will fire the resize event on the window object in intervals for a set
  * amount of time to force the slider to calculate the correct height.
  *
  * [SC] - 3rd Nov 2026 - only fires on pages that actually have a Flickity slider. On every other page these
  * resize events made the whole page recalculate its layout five times for no benefit.
  */


((time, interval) => {
  const startTime = new Date().getTime();
  const intervalId = setInterval(() => {
    if (document.querySelector('.flickity-enabled')) {
      window.dispatchEvent(new Event('resize'));
    }
    if (new Date().getTime() - startTime > time) {
      clearInterval(intervalId);
    }
  }, interval);
})(5000, 1000);
